import React, { useState, useEffect } from "react";
import "./index.css";
import SideBar from "../../components/bibliotecacomponents/sideBar";
import MainDash from "../../components/bibliotecacomponents/mainDash";
import RightSide from "../../components/bibliotecacomponents/rightside";
import Prestamos from "../../components/bibliotecacomponents/prestamos/prestamos";
import EstudiantesHistorial from "../../components/bibliotecacomponents/estudiantesHistorial.js/estudiantesHistorial";
import Inventario from "../../components/bibliotecacomponents/inventario/inventario";
import { useUser } from "../../context/userContext";
import Voluntarios from "../../components/bibliotecacomponents/voluntarios/voluntarios";
import Administracion from "../../components/bibliotecacomponents/administracion/administracion";

function BibliotecaMain() {
  const { userData } = useUser();

  // Determinar la sección inicial según los permisos
  let initialSection = 0; // Por defecto
  if (userData.permisos === "voluntario") {
    initialSection = 3; // Inventario
  }

  const [sectionSelected, setSectionSelected] = useState(initialSection);

  // Definir las secciones disponibles
  const sections = {
    0: (
      <div className="main-dash">
        <MainDash />
        <RightSide />
      </div>
    ),
    1: <Prestamos />,
    2: <EstudiantesHistorial />,
    3: <Inventario />,
    4: <Voluntarios/>,
    5: <Administracion/>
  };

  // Definir los permisos para cada sección
  const allowedSections = {
    0: ["bibliotecario", "admin"],
    1: ["bibliotecario", "admin"],
    2: ["bibliotecario", "admin"],
    3: ["bibliotecario", "admin", "voluntario"],
    4: ["bibliotecario", "admin"], // gestión de voluntarios
    // NUEVA pestaña (si agregas UI) para registrar bibliotecarios:
    5: ["admin"]
  };

  // Verificar si el usuario tiene permiso para la sección seleccionada
  useEffect(() => {
    const currentPermisos = allowedSections[sectionSelected];
    if (!currentPermisos.includes(userData.permisos)) {
      // Cambiar a una sección permitida
      if (userData.permisos === "voluntario") {
        setSectionSelected(3); // Inventario
      } else {
        setSectionSelected(0); // Dashboard
      }
    }
  }, [sectionSelected, userData.permisos]);

  return (
    <div className="biblioteca-main-container">
      <div className="biblioteca-AppGlass">
        <SideBar selected={sectionSelected} setSelected={setSectionSelected} />
        {sections[sectionSelected]}
      </div>
    </div>
  );
}



export default BibliotecaMain;
